<template>
  <ButtonComponent
    :label="$t('copy')"
    :success-label="$t('copied')"
    :icon="['fal', 'copy']"
    :promise="clipPromise"
    v-bind="$attrs"
    v-on="$listeners"
    @click="copy"
  />
</template>

<script>
import { CopyToClipboard } from '@/utils'

export default {
  props: {
    value: {
      type: [String, Number],
    },
  },
  data() {
    return {
      clipPromise: null,
    }
  },
  methods: {
    copy() {
      return (this.clipPromise = Promise.resolve(CopyToClipboard(this.value)))
    },
  },
}
</script>
